import React from 'react';
import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';

import { PageHeader } from '../../components/PageHeader';
import { RotasTab } from './components/RotasTab';
import { TokensTab } from './components/TokensTab';
import { AuditoriaTab } from './components/AuditoriaTab';

export function ApiControllerPage() {
  return (
    <Box>
      <PageHeader
        title="API Controller"
        subtitle="Crie rotas e tokens da API pública de dados (dados-out) e audite o consumo."
      />

      <Tabs colorScheme="blue" variant="enclosed" mt={4}>
        <TabList>
          <Tab>Rotas</Tab>
          <Tab>Tokens</Tab>
          <Tab>Auditoria</Tab>
        </TabList>
        <TabPanels>
          <TabPanel px={0}>
            <RotasTab />
          </TabPanel>
          {/* Criar token é o botão "+ Criar token" dentro da aba Tokens. */}
          <TabPanel px={0}>
            <TokensTab />
          </TabPanel>
          <TabPanel px={0}>
            <AuditoriaTab />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
}
